import React from 'react';
import { Box } from '@mui/material';
import AdminDashboardAuctionDetails from './AdminDashboardAuctionDetails';

const AuctionDetailsInSidebar = () => {
  return (
    <Box sx={{ p: 3, width: '100%' }}>
      <AdminDashboardAuctionDetails />
    </Box>
  );
};

export default AuctionDetailsInSidebar;